export const containerStyles = {
  padding: '32px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
  color: ({ palette }) => palette.text.secondary,
  textAlign: 'center',
};

export const titleStyles = {
  color: ({ palette }) => palette.text.strong,
};

export const actionButtonStyles = {
  marginTop: '8px',
};
